import { useContext } from "react";
import { signedUpContext } from "../guard/signedUpContext";

export function useUser() {
  const context = useContext(signedUpContext);
  if (!context) {
    throw new Error("signedUpContext not initialised");
  }
  return context.user;
}
